import { type FC } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { markdownComponents, urlTransform } from "../../../utils/markdownComponents";
import { Attachment } from "../../../core/types";
import MessageAttachment from "./MessageAttachment";
import { Slot, Templated } from "../../../templating";

interface ChatMessageListUserItemProps {
  messageId: number;
  message: string;
  attachment: Attachment | null;
}

const ChatMessageListUserItem: FC<ChatMessageListUserItemProps> = ({ messageId, message, attachment }) => {
  return (
    <Templated id="lastbot-message-bubble-user">
      <>
        {/* data-message-id lets the list anchor the reader's question to the
            top when the answer to it starts streaming (LAS-1381). */}
        <div className="flex gap-x-4 justify-end" data-message-id={messageId}>
          <div className="shrink-0 w-[30px]"></div>
          <div className="break-words min-w-0" data-testid="user-message">
            <div className="p-4 rounded-lg rounded-tr-none bg-lastbot-bubble-user-surface leading-[1.6] text-lastbot-on-surface formatted-content">
              <Slot name="body">
                <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents} urlTransform={urlTransform}>
                  {message}
                </ReactMarkdown>
              </Slot>
            </div>
          </div>
        </div>
        {attachment && (
          <Slot name="attachment">
            <MessageAttachment attachment={attachment} align="right" />
          </Slot>
        )}
      </>
    </Templated>
  );
};

export default ChatMessageListUserItem;
